/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberSearchListAlbumForMemberResponse } from "./MemberSearchListAlbumForMemberResponse";

export type MemberSearchListAlbumForMemberResponseApiRespoonse = {
  data?: MemberSearchListAlbumForMemberResponse;
  status?: MemberSearchListAlbumForMemberResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberSearchListAlbumForMemberResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
